import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-footer',
  templateUrl: './auth-footer.component.html',
  styleUrls: ['./auth-footer.component.scss'],
  standalone: false,
})
export class AuthFooterComponent {
  public currentYear: number = new Date().getFullYear();
}
